<template>
  <v-card class="elevation-3 mt-6">
    <v-card v-if="isMobile" flat>
      <v-row no-gutters class="pa-2">
        <v-col cols="9">
          <v-card-title class="headline display-1">
            {{ $t("index.documents") }}
          </v-card-title>
        </v-col>
        <v-col cols="3" md="6" class="mt-3 pr-2">
          <v-row justify="center">
            <v-dialog v-model="docFilterDialog">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  {{ $t("tableStatus.filter") }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ $t("tableStatus.filter") }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          :label="$t('tableStatus.by_name')"
                          :items="docNames"
                          clearable
                          v-model="selectedNames"
                          multiple
                          chips
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :label="$t('tableStatus.by_category')"
                          :items="docCategories"
                          clearable
                          v-model="selectedCategories"
                          multiple
                          chips
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-daterange
                          v-model="dateRange"
                          display-format="dd-MM-yyyy"
                          no-title
                          :menu-props="menuProps"
                          :presets="presets"
                          :start-label="$t('labels.start_date')"
                          :end-label="$t('labels.end_date')"
                          :separator-label="$t('labels.to')"
                          :locale="$root.$i18n.locale"
                        ></v-daterange>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="docFilterDialog = false"
                    >OK
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="10" class="mt-n4">
          <v-text-field
            cols="8"
            v-model="search"
            append-icon="search"
            :label="$t('tableStatus.searchName')"
            single-line
            hide-details
            class="mt-n2"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-else flat class="mx-10">
      <v-card-title class="headline display-1">
        {{ $t("index.documents") }}
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('tableStatus.searchName')"
          single-line
          hide-details
          class="mt-n2"
        >
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-card-text class="elevation-2 mb-2 grey lighten-5">
          <v-row no-gutters class="pt-6">
            <v-col cols="3" class="mt-n5 mb-n5">
              <v-select
                :label="$t('tableStatus.filter_name')"
                :items="docNames"
                clearable
                solo
                v-model="selectedNames"
                multiple
              ></v-select>
            </v-col>
            <v-col cols="3" offset="1" class="mt-n5 mb-n5">
              <v-select
                :label="$t('tableStatus.by_category')"
                :items="docCategories"
                clearable
                solo
                chips
                v-model="selectedCategories"
                multiple
              ></v-select>
            </v-col>
            <v-col cols="4" offset="1" class="mt-n5 mb-n5">
              <v-daterange
                v-model="dateRange"
                display-format="dd-MM-yyyy"
                no-title
                :menu-props="menuProps"
                :presets="presets"
                :start-label="$t('labels.start_date')"
                :end-label="$t('labels.end_date')"
                :separator-label="$t('labels.to')"
                :locale="$root.$i18n.locale"
              ></v-daterange>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card-text>
    </v-card>
    <v-row justify="center">
      <v-col v-if="isMobile" cols="12">
        <v-list style="max-height: 640px; overflow: auto">
          <v-list-item-group color="primary">
            <template v-if="loadingDoc">
              <v-list-item v-for="(item, i) in 2" :key="i">
                <v-list-item-content>
                  <v-skeleton-loader
                    ref="skeleton"
                    type="list-item-avatar-two-line"
                    class="mx-auto"
                  ></v-skeleton-loader>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item v-for="item in docList" :key="item.id">
                <v-list-item-avatar>
                  <v-icon large color="primary">
                    {{ documentIcon(item.mime) }}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.name"
                    @click="openFile(item)"
                    title="Ouvrir le document dans une nouvelle fenêtre"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-if="item.documentcategories_id !== 0"
                    v-text="item.documentcategories_id"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-text="
                      moment(item.date_creation, 'YYYY-MM-Do HH:mm ss').format(
                        ' Do MMM YYYY, HH:mm'
                      )
                    "
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    color="primary"
                    @click="downloadFile(item)"
                    :title="$t('assetDetails.text3')"
                  >
                    <v-icon dark>mdi-cloud-download-outline</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col v-else cols="10">
        <v-list style="max-height: 640px; overflow: auto">
          <v-list-item-group color="primary">
            <template v-if="loadingDoc">
              <v-list-item v-for="(item, i) in 2" :key="i">
                <v-list-item-content>
                  <v-skeleton-loader
                    ref="skeleton"
                    type="list-item-avatar-two-line"
                    class="mx-auto"
                  ></v-skeleton-loader>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item v-for="item in docList" :key="item.id">
                <v-list-item-avatar>
                  <v-icon large color="primary">
                    {{ documentIcon(item.mime) }}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.name"
                    @click="openFile(item)"
                    :title="$t('assetDetails.text2')"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-if="item.documentcategories_id !== 0"
                    v-text="item.documentcategories_id"
                  ></v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-text="
                      moment(item.date_creation, 'YYYY-MM-Do HH:mm ss').format(
                        ' Do MMM YYYY, HH:mm'
                      )
                    "
                  ></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    class="mx-2"
                    fab
                    dark
                    small
                    color="primary"
                    @click="downloadFile(item)"
                    :title="$t('assetDetails.text3')"
                  >
                    <v-icon dark>mdi-cloud-download-outline</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "../../plugins/moment";
import VDaterange from "../VDaterange";
import USER_API from "../../api/user";
import { permissions } from "../../utils";

export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  components: { VDaterange },
  data() {
    return {
      documentsList: [],
      loadingDoc: false,
      activeEntity: null,
      docFilterDialog: false,
      selectedNames: [],
      selectedCategories: [
        this.$t("index.lease"),
        this.$t("index.account"),
        this.$t("index.rent"),
        this.$t("index.plan"),
        this.$t("index.management"),
        this.$t("index.procurement"),
        this.$t("index.dpe"),
        this.$t("index.logo"),
        this.$t("index.photo_corporate")
      ],
      search: "",
      dateRange: {},
      menuProps: { offsetY: true, closeOnContentClick: false },
      presets: [
        {
          label: this.$t("index.today"),
          range: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
        },
        {
          label: this.$t("index.yesterday"),
          range: [
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD"),
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD")
          ]
        },
        {
          label: this.$t("index.last_days"),
          range: [
            moment()
              .subtract(30, "days")
              .format("YYYY-MM-DD"),
            moment()
              .subtract(1, "days")
              .format("YYYY-MM-DD")
          ]
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUserProfiles", "getUserId"]),

    docNames() {
      return this.authorizedDocs.map(doc => doc.name);
    },
    docCategories() {
      let categories = this.authorizedDocs.map(doc => {
        if (doc.documentcategories_id === 0) {
          return this.$t("labels.no_category");
        }
        return doc.documentcategories_id;
      });
      return [...new Set(categories)];
    },
    authorizedDocs() {
      return this.documentsList.filter(doc => {
        const comment = "" + doc.comment;
        const per = comment.substring(0, 3);
        return this.checkDocPermission(per);
      });
    },
    filteredDocList() {
      return this.authorizedDocs.filter(doc => {
        if (doc.documentcategories_id === 0) {
          doc.documentcategories_id = this.$t("labels.no_category");
        }
        const dateCreation = moment(
          doc.date_creation,
          "YYYY-MM-Do HH:mm ss"
        ).format("YYYY-MM-DD");

        return (
          (this.selectedNames.length === 0 ||
            this.selectedNames.includes(doc.name)) &&
          (this.selectedCategories.length === 0 ||
            this.selectedCategories.includes(doc.documentcategories_id)) &&
          this.filterByDate(dateCreation)
        );
      });
    },
    docList() {
      if (!this.search) return this.filteredDocList;
      return this.filteredDocList.filter(doc => {
        if (doc.documentcategories_id === 0)
          doc.documentcategories_id = this.$t("labels.no_category");

        return (
          doc.name.toLowerCase().search(this.search.toLowerCase()) > -1 ||
          doc.documentcategories_id
            .toLowerCase()
            .search(this.search.toLowerCase()) > -1
        );
      });
    },
    isMobile() {
      return (
        this.$vuetify.breakpoint.width < this.$vuetify.breakpoint.thresholds.md
      );
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    moment,
    getEntityParentName(entity) {
      let parent = this.getEntity.find(ent => ent.id === entity.entities_id);
      return parent ? parent.name : "";
    },
    loadData() {
      if (this.active) {
        USER_API.loadDoc()
          .then(response => {
            const docs = response.data;
            this.documentsList = docs;
            /*.filter(
              doc => doc.entities_id === this.$route.params.id
            );*/
          })
          .finally(() => {
            this.loadingDoc = false;
          });
      }
    },
    documentIcon(mimeType) {
      if (mimeType === "image/jpeg") {
        return "mdi-folder-image";
      } else if (mimeType === "application/pdf") {
        return "mdi-file-pdf";
      } else {
        return "mdi-folder";
      }
    },
    downloadFile(item) {
      USER_API.downloadDocument(item);
    },
    openFile(item) {
      USER_API.openDocument(item);
    },
    formatDate(date) {
      if (!date) return null;

      return moment(date).format("DD-MM-YYYY");
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    filterByDate(date) {
      if (!this.dateRange.start && !this.dateRange.end) return true;
      return this.dateRange.start <= date && this.dateRange.end >= date;
    },
    checkDocPermission(permission) {
      const permissionSize = permission.length;
      if (permissionSize > 2) {
        const publique = permission[0];
        const occupant = permission[1];
        const investisseur = permission[2];

        let per = false;
        if (publique.toUpperCase() === "X") {
          per = permissions.profileDocPermission(
            "publique",
            this.getUserProfiles
          );
          if (per) return true;
        }

        if (occupant.toUpperCase() === "X") {
          per = permissions.profileDocPermission(
            "occupant",
            this.getUserProfiles
          );
          if (per) return true;
        }
        if (investisseur.toUpperCase() === "X") {
          per = permissions.profileDocPermission(
            "investisseur",
            this.getUserProfiles
          );

          if (per) return true;
        }

        return false;
      }
      return false;
    }
  },
  watch: {
    $route() {
      this.loadData();
    },
    active() {
      this.loadData();
    }
  }
};
</script>
